module.exports = __webpack_public_path__ + "b22715183c068b0120ae96598b621657.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow.svg
// module id = 159
// module chunks = 0 1